import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/ui/Header';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';
import DashboardStats from './components/DashboardStats';
import UpcomingTrips from './components/UpcomingTrips';
import TripHistory from './components/TripHistory';
import SavedTours from './components/SavedTours';
import QuickActions from './components/QuickActions';
import TravelInsights from './components/TravelInsights';

const UserDashboard = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('overview');
  const [user, setUser] = useState({
    name: "Sarah Johnson",
    email: "sarah.johnson@email.com",
    memberSince: "2022-03-15",
    profileImage: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face"
  });

  const [dashboardStats, setDashboardStats] = useState({
    totalTrips: 12,
    countriesVisited: 8,
    loyaltyPoints: 2450,
    totalSavings: 1250
  });

  const [upcomingTrips, setUpcomingTrips] = useState([
    {
      id: "trip-001",
      tourId: "tour-123",
      title: "Magical Bali Adventure",
      destination: "Bali, Indonesia",
      startDate: "2024-12-15",
      endDate: "2024-12-22",
      travelers: 2,
      status: "confirmed",
      image: "https://images.unsplash.com/photo-1537953773345-d172ccf13cf1?w=400&h=300&fit=crop"
    },
    {
      id: "trip-002",
      tourId: "tour-456",
      title: "Swiss Alps Hiking Experience",
      destination: "Interlaken, Switzerland",
      startDate: "2025-01-20",
      endDate: "2025-01-27",
      travelers: 1,
      status: "pending",
      image: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=400&h=300&fit=crop"
    }
  ]);

  const [tripHistory, setTripHistory] = useState([
    {
      id: "trip-h001",
      tourId: "tour-789",
      title: "Tokyo Cultural Discovery",
      destination: "Tokyo, Japan",
      startDate: "2024-09-10",
      endDate: "2024-09-17",
      status: "completed",
      totalPaid: 2800,
      hasReview: true,
      rating: 5,
      image: "https://images.unsplash.com/photo-1540959733332-eab4deabeeaf?w=400&h=300&fit=crop"
    },
    {
      id: "trip-h002",
      tourId: "tour-101",
      title: "Paris Romance Package",
      destination: "Paris, France",
      startDate: "2024-06-05",
      endDate: "2024-06-12",
      status: "completed",
      totalPaid: 3200,
      hasReview: false,
      rating: 0,
      image: "https://images.unsplash.com/photo-1502602898536-47ad22581b52?w=400&h=300&fit=crop"
    },
    {
      id: "trip-h003",
      tourId: "tour-202",
      title: "Iceland Northern Lights",
      destination: "Reykjavik, Iceland",
      startDate: "2024-02-14",
      endDate: "2024-02-21",
      status: "cancelled",
      totalPaid: 2100,
      hasReview: false,
      rating: 0,
      image: "https://images.unsplash.com/photo-1539066834862-2e0c2e2c9b8a?w=400&h=300&fit=crop"
    }
  ]);

  const [savedTours, setSavedTours] = useState([
    {
      id: "saved-001",
      title: "Santorini Sunset & Wine Tour",
      location: "Santorini, Greece",
      price: 180,
      originalPrice: 220,
      rating: 4.8,
      duration: "6 hours",
      availability: 8,
      priceDropped: true,
      limitedOffer: false,
      savedDate: "2024-11-15",
      image: "https://images.unsplash.com/photo-1570077188670-e3a8d69ac5ff?w=400&h=300&fit=crop",
      bookings: 1250
    },
    {
      id: "saved-002",
      title: "Amazon Rainforest Adventure",
      location: "Manaus, Brazil",
      price: 450,
      originalPrice: 450,
      rating: 4.9,
      duration: "3 days",
      availability: 3,
      priceDropped: false,
      limitedOffer: true,
      savedDate: "2024-11-10",
      image: "https://images.unsplash.com/photo-1516026672322-bc52d61a55d5?w=400&h=300&fit=crop",
      bookings: 890
    },
    {
      id: "saved-003",
      title: "Moroccan Desert Safari",
      location: "Marrakech, Morocco",
      price: 320,
      originalPrice: 380,
      rating: 4.7,
      duration: "2 days",
      availability: 0,
      priceDropped: true,
      limitedOffer: false,
      savedDate: "2024-11-08",
      image: "https://images.unsplash.com/photo-1539650116574-75c0c6d73f6e?w=400&h=300&fit=crop",
      bookings: 2100
    }
  ]);

  const [notifications, setNotifications] = useState([
    {
      id: "notif-001",
      type: "booking",
      title: "Booking Confirmed",
      message: "Your Bali Adventure trip has been confirmed for Dec 15-22",
      timestamp: "2024-11-18T10:30:00Z",
      read: false
    },
    {
      id: "notif-002",
      type: "payment",
      title: "Payment Successful",
      message: "Payment of $2,800 processed for Swiss Alps Hiking",
      timestamp: "2024-11-17T14:15:00Z",
      read: false
    },
    {
      id: "notif-003",
      type: "reminder",
      title: "Trip Reminder",
      message: "Your Bali trip starts in 27 days. Don't forget to check your documents!",
      timestamp: "2024-11-16T09:00:00Z",
      read: true
    },
    {
      id: "notif-004",
      type: "offer",
      title: "Special Offer",
      message: "20% off on your next European tour booking. Limited time!",
      timestamp: "2024-11-15T16:45:00Z",
      read: true
    }
  ]);

  const [travelInsights, setTravelInsights] = useState({
    favoriteDestination: "Japan",
    averageTripCost: 2650,
    tripsThisYear: 4,
    nextMilestone: "Explorer Badge (15 trips)",
    goals: [
      {
        id: "goal-1",
        title: "Visit 10 Countries",
        current: 8,
        target: 10
      },
      {
        id: "goal-2",
        title: "Complete 15 Tours",
        current: 12,
        target: 15
      },
      {
        id: "goal-3",
        title: "Earn 3000 Points",
        current: 2450,
        target: 3000
      }
    ],
    recommendations: [
      "Based on your love for cultural tours, consider our new Heritage Trail in Peru",
      "You\'ve saved 15% on average with early bookings - keep it up!",
      "Your next trip to Switzerland is perfect for winter sports activities",
      "Consider travel insurance for your upcoming international trips"
    ]
  });

  const tabs = [
    { id: 'overview', label: 'Overview', icon: 'LayoutDashboard' },
    { id: 'upcoming', label: 'Upcoming Trips', icon: 'Calendar' },
    { id: 'history', label: 'Trip History', icon: 'History' },
    { id: 'saved', label: 'Saved Tours', icon: 'Heart' },
    { id: 'insights', label: 'Travel Insights', icon: 'BarChart3' }
  ];

  const handleRemoveFromWishlist = (tourId) => {
    setSavedTours(prev => prev?.filter(tour => tour?.id !== tourId));
  };

  const handleMarkAllNotificationsRead = () => {
    setNotifications(prev => prev?.map(notif => ({ ...notif, read: true })));
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case 'overview':
        return (
          <div className="space-y-8">
            <DashboardStats stats={dashboardStats} />
            {/* Welcome Section */}
            <div className="bg-gradient-to-r from-primary to-accent rounded-xl p-6 text-white">
              <div className="flex items-center justify-between">
                <div>
                  <h2 className="text-2xl font-bold mb-2">Welcome back, {user?.name}!</h2>
                  <p className="opacity-90">Ready for your next adventure? Your Bali trip is coming up soon!</p>
                </div>
                <div className="hidden lg:block">
                  <Icon name="Compass" size={64} className="opacity-20" />
                </div>
              </div>
            </div>
            {/* Quick Overview */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              <div>
                <div className="flex items-center justify-between mb-4">
                  <h3 className="text-lg font-semibold text-foreground">Upcoming Trips</h3>
                  <Button
                    variant="ghost"
                    size="sm"
                    onClick={() => setActiveTab('upcoming')}
                    iconName="ArrowRight"
                    iconPosition="right"
                  >
                    View All
                  </Button>
                </div>
                <UpcomingTrips trips={upcomingTrips?.slice(0, 2)} />
              </div>
              
              <div>
                <QuickActions 
                  notifications={notifications?.filter(n => !n?.read)?.slice(0, 3)} 
                  onMarkAllRead={handleMarkAllNotificationsRead}
                />
              </div>
            </div>
          </div>
        );
      
      case 'upcoming':
        return <UpcomingTrips trips={upcomingTrips} />;
      
      case 'history':
        return <TripHistory trips={tripHistory} />;
      
      case 'saved':
        return <SavedTours savedTours={savedTours} onRemoveFromWishlist={handleRemoveFromWishlist} />;
      
      case 'insights':
        return <TravelInsights insights={travelInsights} />;
      
      default:
        return null;
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <div className="max-w-7xl mx-auto px-4 lg:px-6 py-8">
        {/* Page Header */}
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between mb-8">
          <div className="mb-4 lg:mb-0">
            <h1 className="text-3xl font-bold text-foreground mb-2">My Dashboard</h1>
            <p className="text-muted-foreground">
              Manage your bookings, explore new destinations, and track your travel journey
            </p>
          </div>
          
          {/* User Profile Quick Info */}
          <div className="flex items-center space-x-4">
            <div className="text-right hidden sm:block">
              <p className="font-medium text-foreground">{user?.name}</p>
              <p className="text-sm text-muted-foreground">
                Member since {new Date(user.memberSince)?.getFullYear()}
              </p>
            </div>
            <button
              onClick={() => navigate('/profile-management')}
              className="w-12 h-12 rounded-full overflow-hidden border-2 border-primary hover:border-accent transition-colors"
            >
              <img
                src={user?.profileImage}
                alt={user?.name}
                className="w-full h-full object-cover"
                onError={(e) => {
                  e.target.src = '/assets/images/no_image.png';
                }}
              />
            </button>
          </div>
        </div>

        {/* Tab Navigation */}
        <div className="border-b border-border mb-8">
          <div className="flex space-x-1 overflow-x-auto">
            {tabs?.map((tab) => (
              <button
                key={tab?.id}
                onClick={() => setActiveTab(tab?.id)}
                className={`flex items-center space-x-2 px-4 py-3 text-sm font-medium rounded-t-lg transition-colors whitespace-nowrap ${
                  activeTab === tab?.id
                    ? 'text-primary border-b-2 border-primary bg-primary/5' :'text-muted-foreground hover:text-foreground hover:bg-muted/50'
                }`}
              >
                <Icon name={tab?.icon} size={16} />
                <span>{tab?.label}</span>
              </button>
            ))}
          </div>
        </div>

        {/* Tab Content */}
        <div className="animate-fade-in">
          {renderTabContent()}
        </div>
      </div>
    </div>
  );
};

export default UserDashboard;